// AUTO-GENERATED by scripts/build-images.mjs — do not edit by hand.
export const images = {
  "about-artisan-credenza": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "about-atelier-workshop": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "about-hero-living-room": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "about-material-palette": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "about-stone-quarry": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "about-teak-fluted-detail": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "contact-map-nagercoil": {
    "width": 512,
    "height": 512,
    "widths": [
      480,
      512
    ]
  },
  "contact-marble-walnut": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "contact-principal-portrait": {
    "width": 286,
    "height": 512,
    "widths": [
      286
    ]
  },
  "contact-walk-in-wardrobe": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "home-after-living-room": {
    "width": 512,
    "height": 286,
    "widths": [
      480,
      512
    ]
  },
  "home-before-concrete": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "home-hero-living-room": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "home-service-commercial": {
    "width": 512,
    "height": 286,
    "widths": [
      480,
      512
    ]
  },
  "home-service-office": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "home-service-residential": {
    "width": 512,
    "height": 286,
    "widths": [
      480,
      512
    ]
  },
  "journal-acoustic-great-room": {
    "width": 512,
    "height": 286,
    "widths": [
      480,
      512
    ]
  },
  "journal-author-portrait": {
    "width": 286,
    "height": 512,
    "widths": [
      286
    ]
  },
  "journal-biophilic-atrium": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "journal-good-to-great": {
    "width": 512,
    "height": 286,
    "widths": [
      480,
      512
    ]
  },
  "journal-lead-pavilion": {
    "width": 512,
    "height": 318,
    "widths": [
      480,
      512
    ]
  },
  "journal-limewash-bedroom": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "journal-media-wall": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "journal-minimal-design": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "journal-natural-stones": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "journal-oak-library": {
    "width": 512,
    "height": 318,
    "widths": [
      480,
      512
    ]
  },
  "journal-wall-shelves": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "material-brass": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "material-emerald-quartzite": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "material-linen-silk": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "material-microcement": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "material-reeded-glass": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "material-teak": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-classic-villa": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-eco-green-interior": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-executive-office": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-gourmet-dining": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-heritage-manor-dining": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-modern-elegant-suite": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-modular-kitchen": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-palm-grove-courtyard": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-pinnacle-boardroom": {
    "width": 512,
    "height": 286,
    "widths": [
      480,
      512
    ]
  },
  "project-precision-kitchen": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-primary-suite": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-sanctuary-basin": {
    "width": 512,
    "height": 286,
    "widths": [
      480,
      512
    ]
  },
  "project-skyline-penthouse": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "project-travertine-oak-study": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "services-boutique-restaurant": {
    "width": 512,
    "height": 286,
    "widths": [
      480,
      512
    ]
  },
  "services-corporate-boardroom": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "services-residential-living": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "services-walnut-joinery": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "team-interior-architect": {
    "width": 512,
    "height": 286,
    "widths": [
      480,
      512
    ]
  },
  "team-master-woodworker": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "team-principal-architect": {
    "width": 512,
    "height": 279,
    "widths": [
      480,
      512
    ]
  },
  "team-project-director": {
    "width": 382,
    "height": 512,
    "widths": [
      382
    ]
  }
} as const;

export type ImageName = keyof typeof images;
